<template >
  <b-row :class="black ? 'fp_bloc_bl' : 'mf_bg fp_bloc'">
    <div class="title_bloc">Horizon de placement (ans)</div>
    <b-col sm="9" class="mb-2">
      <input
        type="range"
        class="form-range fp_customRange"
        id="customRange1"
        v-model="nb"
        min="1"
        step="1"
        max="30"
      />
    </b-col>
    <b-col sm="3" class="mf_purple_info">{{ nb }}</b-col>
  </b-row>
</template>
<script>
export default {
  props: ["year", "black"],
  data() {
    return {
      nb: this.year
    };
  }
};
</script>
<style lang="scss">
@import "./resources/sass/_variables.scss";

.fp_bloc_bl {
  width: 60%;
  margin: auto;
  width: 60%;
  margin: auto;
  padding: 15px;
  margin-top: 20px;
  margin-bottom: 50px;
  justify-content: center;

  background: #333436 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 33px;
  opacity: 1;

  // @extend .mf_bg;
  // padding-bottom: 0.5rem;

  .fp_bloc_content {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
  }

  .title_bloc {
    margin-bottom: 10px;
    margin-top: 10px;
    color: var(--unnamed-color-ffffff);
    text-align: center;
    letter-spacing: NaNpx;
    color: $mf_ft_color_white;
    opacity: 1;
  }
  input[type="range"]::-webkit-slider-thumb {
    margin-top: -7.85px;
    width: 30px;
    height: 30px;
    background: #5c5c5c;
    border: 0px solid rgba(0, 0, 0, 0);
    border: 0;
    border-radius: 50px;
    cursor: pointer;
    -webkit-appearance: none;
  }
  button {
    background: #242527 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    opacity: 0.6;
    &:hover {
      background: $bg_color;
    }
  }
}
</style>